if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        if (this.classList.contains('slynara-quick-add')) {
          document.body.addEventListener('modalClosed', () => {
            window.setTimeout(() => {
              if (this.hasAttribute('open')) document.body.classList.add('overflow-hidden');
            });
          });
        }

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        document.querySelectorAll('[data-slynara-quick-add-owner]').forEach((modal) => {
          if (modal.dataset.slynaraQuickAddOwner === this.id) modal.remove();
        });
        this.slynaraSizeGuideHTML = '';
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            this.prepareSlynaraQuickAdd(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            this.mountSlynaraSizeGuide();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.modalContent.querySelector('product-component')?.dispatchViewEvent?.();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) {
          modalDialog.forEach((modal) => {
            if (this.classList.contains('slynara-quick-add') && modal.classList.contains('slynara-size-guide')) {
              modal.dataset.slynaraQuickAddOwner = this.id;
              this.slynaraSizeGuideHTML = modal.outerHTML;
              modal.remove();
              return;
            }
            modal.remove();
          });
        }
      }

      prepareSlynaraQuickAdd(productElement) {
        if (!this.classList.contains('slynara-quick-add')) return;

        productElement.classList.add('slynara-quick-add__product');
        productElement.querySelector('.slynara-product-information')?.remove();
        productElement.querySelector('.product-form__quantity')?.remove();
        productElement.querySelector('.product__tax')?.remove();
        productElement.querySelector('slynara-sticky-atc')?.remove();

        const productLayout = productElement.querySelector('.product');
        const mediaWrapper = productElement.querySelector('.product__media-wrapper');
        const infoWrapper = productElement.querySelector('.product__info-wrapper');
        const infoContainer = infoWrapper?.querySelector('.product__info-container');
        if (productLayout && mediaWrapper && infoWrapper && infoContainer) {
          mediaWrapper.classList.remove('product__column-sticky');
          mediaWrapper.querySelector('media-gallery')?.classList.remove('product__column-sticky');
          mediaWrapper.querySelector('[data-media-colors]')?.remove();
          const summary = document.createElement('div');
          const summaryMeta = document.createElement('div');
          summary.className = 'slynara-quick-add__summary';
          summaryMeta.className = 'slynara-quick-add__summary-meta';

          const eyebrow = infoContainer.querySelector('.product__text');
          const title = infoContainer.querySelector('.product__title');
          const price = infoContainer.querySelector('[id^="price-"]');
          [eyebrow, title, price].forEach((item) => {
            if (item) summaryMeta.appendChild(item);
          });

          summary.append(mediaWrapper, summaryMeta);
          productLayout.insertBefore(summary, infoWrapper);
        }

        const sizeGuideOpener = productElement.querySelector('.slynara-size-guide__opener');
        sizeGuideOpener?.classList.remove('quick-add-hidden');

        const delivery = productElement.querySelector('.slynara-product-delivery');
        const returnsLink = delivery?.querySelector('a[href*="returns-exchanges"]');
        if (delivery && returnsLink) {
          const list = document.createElement('ul');
          list.className = 'slynara-quick-add__reassurance';
          ['Processing: 1–3 business days', 'Delivery: 7–12 business days'].forEach(
            (text) => {
              const item = document.createElement('li');
              item.textContent = text;
              list.appendChild(item);
            }
          );
          const returnsItem = document.createElement('li');
          const link = returnsLink.cloneNode();
          link.textContent = 'Returns & Exchanges';
          returnsItem.appendChild(link);
          list.appendChild(returnsItem);
          delivery.replaceChildren(list);
        }

      }

      mountSlynaraSizeGuide() {
        if (!this.slynaraSizeGuideHTML) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'shopify-section';
        wrapper.id = `shopify-section-${this.id}-size-guide`;
        wrapper.innerHTML = this.slynaraSizeGuideHTML;
        document.body.appendChild(wrapper);
        wrapper.remove();
        this.slynaraSizeGuideHTML = '';
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
